<script setup>
  const { error } = defineProps(['error']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <Section autowrap>
    <h2>{{ error }}</h2>
  </Section>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  h2 {
    color: $red;
  }
</style>
